import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { GetBannersParams } from '../../__generated__/gateway/gatewayApiTypes';
import { getBanners } from '../../services/advertising';
import type { TBannersList } from '../../types/advertising';

export interface IState {
  banners: TBannersList;
  loaded: boolean;
}

const initialState: IState = {
  banners: null,
  loaded: false,
};

export const fetchBanners = createAsyncThunk<TBannersList, GetBannersParams>(
  `advertising/fetchBanners`,
  async (params) => getBanners(params),
);

const advertisingSlice = createSlice({
  name: 'advertising',
  initialState,
  reducers: {
    setBanners: (state, { payload }: PayloadAction<TBannersList>) => {
      state.banners = payload;
      state.loaded = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBanners.fulfilled, (state, { payload }) => {
      state.banners = payload;
    });
  },
});

const { actions, reducer } = advertisingSlice;

export const { setBanners } = actions;

export default reducer;
